/*
 * @Auther: 罗耀祖
 * @Date: 2022-04-26 14:45:23
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-04-26 14:50:02
 * @name: 销售副总审批
 * @Description: 销售副总审批
 * @FilePath: \project\src\module\issue\validator\secondBoss.js
 * @Author: desktop
 */
export const validator = [
  {
    key: 'run_process_id',
    description: '流程id',
    required: true,
    required_message: '流程id为必传项',
    match: (e) => {
      return '';
    }
  },
  {
    key: 'issue_id',
    description: '工单id',
    required: true,
    required_message: '工单id为必传项',
    match: (e) => {
      return '';
    }
  },
  {
    key: 'pay_fee',
    description: '支付金额',
    required: true,
    required_message: '支付金额为必传项',
    match: (e) => {
      if (!e) {
        return '支付金额为必填项';
      } else {
        return '';
      }
    },
    match_toast: true,
  },
  {
    key: 'act',
    description: '是否通过',
    required: true,
    required_message: 'act为必传项',
    match: (e) => {
      return '';
    }
  },
  {
    key: 'remark',
    description: '备注',
    required: false,
    match: (e) => {
      return '';
    }
  },
]